export enum FileCategory {
  COVER_LETTER = 'COVER_LETTER',
  CRIMINAL_RECORD = 'CRIMINAL_RECORD',
  CV = 'CV',
  DIPLOMA = 'DIPLOMA',
  CERTIFICATE_OF_COMPLETION = 'CERTIFICATE_OF_COMPLETION',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  HEALTH_CARD = 'HEALTH_CARD',
  IDENTITY_DOCUMENT_RECTO = 'IDENTITY_DOCUMENT_RECTO',
  IDENTITY_DOCUMENT_VERSO = 'IDENTITY_DOCUMENT_VERSO',
  ONI_CERTIFICATE = 'ONI_CERTIFICATE',
  OTHER_DOCUMENT = 'OTHER_DOCUMENT',
  RESIDENCE_PROOF = 'RESIDENCE_PROOF',
  RIB = 'RIB',
  SS_CERTIFICATE = 'SS_CERTIFICATE',
  VACCINATION_RECORD_DTP = 'VACCINATION_RECORD_DTP',
  VACCINATION_RECORD_HEPATITIS_B = 'VACCINATION_RECORD_HEPATITIS_B',
  VACCINATION_RECORD_REPEVAX = 'VACCINATION_RECORD_REPEVAX',
  WORK_CERTIFICATE = 'WORK_CERTIFICATE',
  ADELI_CERTIFICATE = 'ADELI_CERTIFICATE',
  INSTITUTION_LOGO = 'INSTITUTION_LOGO',
  INSTITUTION_COVER_PICTURE = 'INSTITUTION_COVER_PICTURE',
}
